import { render, staticRenderFns } from "./EditCompanyLogo.vue?vue&type=template&id=0bb823c7&scoped=true"
import script from "./EditCompanyLogo.vue?vue&type=script&lang=js"
export * from "./EditCompanyLogo.vue?vue&type=script&lang=js"
import style0 from "./EditCompanyLogo.vue?vue&type=style&index=0&id=0bb823c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb823c7",
  null
  
)

export default component.exports